import {RepositoryFactory} from '../../api/RepositoryFactory';

export default {
    actions: {
        GET_LESSONS: async (context) => {
            await RepositoryFactory.get('lessons').get().then((res) => {
                context.commit('SET_LESSONS', res.data.lessons)
            });
        },

        ADD_LESSON: async (context, payload) => {
            await RepositoryFactory.get('lessons').create(payload).then((res) => {
                context.commit('ADD_LESSON', res.data.lesson)
            });
        }
    },

    mutations: {
        SET_LESSONS: (state, payload) => {
            state.lessons = payload;
        },

        ADD_LESSON: (state, payload) => {
            state.lessons.unshift(payload);
        }
    },

    state: {
        lessons: []
    },

    getters: {
        LESSONS: state => {
            return state.lessons;
        }
    }
}